import { API } from '@/api';
import { fetcher, HTTPError } from '@/services/fetcher';

import { type ChangeContractStatusParams, contractApiSchema } from '../../models';
import { logger } from '../../utils/logger';

const contracts = fetcher.extend(() => ({ prefixUrl: `${API.CONTRACTS}` }));

export const changeContractStatus = async (
  { comment, contractKey, status }: ChangeContractStatusParams,
  { signal }: { signal?: AbortController['signal'] } = {},
) => {
  try {
    return await contracts
      .put(`${contractKey}/$change-status`, {
        json: { comment: comment || null, status },
        signal,
      })
      .json(contractApiSchema);
  } catch (error) {
    if (error instanceof HTTPError) {
      logger.error(`Error: ${error.response.status}`);
    }
    throw error;
  }
};
